<template>
	<div class="layout-grid-display">
		<layout-grid-header @onCategoryChange="onCategoryChange" @updateBookFormats="updateBookFormats" :create-layout-function="createLayoutFunction" @onFilter="onFilter" :layout-type="layoutType" :layout-type-display="layoutTypeDisplay" :has-categories="hasCategories" :create-if-missing="createIfMissing" :org-id="orgId" />
		<p></p>
		<div style="margin-bottom: 1em;" v-if="layoutCategory">
			<div class="ui tiny basic label" v-for="bookFormat in currentBookFormats" :key="bookFormat.formatId"><i class="book icon"></i>{{ bookFormat.name }}</div>
		</div>
		<layout-grid :layout-category="layoutCategory" :create-layout-actions="createLayoutActions" :filter="filter" :layout-type-display="layoutTypeDisplay" :layout-type="layoutType" :org-id="orgId" :job-id="jobId" :season-id="seasonId" />
	</div>
</template>

<script>
import LayoutGrid from './LayoutGrid.vue';
import LayoutGridHeader from './LayoutGridHeader.vue';

export default {
	props: {
		createLayoutActions: null,
		createLayoutFunction: null,
		layoutType: {
			default: 2
		},
		hasCategories: {
			type: Boolean,
			default: true
		},
		createIfMissing: {
			default: true
		},
		orgId: null,
		jobId: null,
		seasonId: null
	},
	data: function() {
		return {
			layoutCategory: null,
			filter: '',
			bookFormats: []
		};
	},
	computed: {
		loading: function() {
			return !this.layoutCategory;
		},
		layoutTypeDisplay: function() {
			if(this.layoutType == 'Candid') {
				return 'Candid Layout';
			} else {
				return this.layoutType;
			}
		},
		currentBookFormats: function() {
			var bookFormats = [];

			if(this.layoutCategory && this.layoutCategory.bookFormatIds && this.bookFormats) {
				var allBookFormats = this.bookFormats;
				this.layoutCategory.bookFormatIds.forEach(function(bookFormatId) {
					var bookFormat = allBookFormats.filter(function(bookFormat) {
						return bookFormat.formatId === bookFormatId;
					})[0];

					if(bookFormat) {
						bookFormats.push(bookFormat);
					}
				});
			}

			return bookFormats;
		}
	},
	methods: {
		onCategoryChange: function(layoutCategory) {
			this.layoutCategory = layoutCategory;
		},
		onFilter: function(filter) {
			this.filter = filter;
		},
		updateBookFormats: function(bookFormats) {
			this.bookFormats = bookFormats;
		}
	},
	mounted: function() {
		if(!this.hasCategories) {
			this.layoutCategory = {
				id: 'global'
			};
		}
	},
	components: {
		LayoutGrid,
		LayoutGridHeader
	}
};
</script>